export default ($resource) => {
    const url = `${SEED_CORE.ENV.API_URL}form/meta-field/:id`;

    return $resource(url, null, {
        update: {
            method: 'PUT',
            url
        }
    });
};



// WEBPACK FOOTER //
// ./src/app/resources/MetaField/index.js